import * as React from 'react';
import { useEffect } from 'react';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useHomepage } from '../../hooks/useQueries';
import { useAppContext } from '../../providers/AppContext';
import SEOCmp from '../../components/common/SEOCmp';

export default function HomePage() {
  const { data: result } = useHomepage();
  const { setPageTitle } = useAppContext();

  useEffect(() => {
    setPageTitle('');
  }, [setPageTitle]);

  return (
    <Container>
      <SEOCmp />
      {result?.result ? (
        <Row className="g-3">
          {result.result.map((site) => (
            <Col key={site.id} sm="6" md="4" lg="3">
              <Link to={`/site/${site.id}${site.slug ? `/${site.slug}` : ''}`} style={{ textDecoration: 'none' }}>
                <Card className="h-100">
                  <CardBody>{site.siteTitle}</CardBody>
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
      ) : (
        <React.Fragment />
      )}
    </Container>
  );
}
